import { RootState } from "../../../../Store";

// responsible for retrieving data as it appears in the redux store
export const userSelector = (state: RootState) => state.user;
